export default "<div class=\"container-fluid\">\r\n  <p>You're not authorized to access this application!</p>\r\n\r\n</div>";